var prongHorn = prongHorn || {};

prongHorn.product = prongHorn.product || function() {
    var self = this;

    this.init = function() {
        self.updateCountry();
        self.updateVoucher();
        self.addToCart();
    };
    
    this.ajaxSubmit = function($form) {
        var $submit = $form.find('button[type="submit"]');
        var productId = $form.find('input[name="ProductID"]').val();
        
        var productPageNameElement = document.getElementById("product");        
        var url = productPageNameElement.dataset.productpagename + "?ProductID=";      
        
        // Make ajax call form submission
        $.ajax({
            url: url + productId,
            type: 'POST',
            cache: false,
            data: $form.serialize(),
            success: function (result) {
                self.updateMiniCart(result);
                self.ajaxMsg($form, true);
            }
        });
    }

    this.ajaxMsg = function($form, success) {

        // Check if the success state is set to true - else show a error msg
        if(success){
            $form.removeClass('form--ajax-error');
            $form.addClass('form--ajax-success');

            // Remove the success after 2000ms
            setTimeout(function() {
                $form.removeClass('form--ajax-success');
            }, 5000);
            
        } else {
            $form.addClass('form--ajax-error');
            $form.removeClass('form--ajax-success');
        };

    }

    self.updateMiniCart = function(data) {
        var $data = $(data);
        var $minicartCount = $('.mini-cart__circle');
        var newCount = $data.find('.mini-cart__circle').html();


        $minicartCount.html(newCount);

        // Animate the icon
        $minicartCount.removeClass('mini-cart__circle--hidden');
        $minicartCount.addClass('mini-cart__circle--update');
        setTimeout(function() {
            $minicartCount.removeClass('mini-cart__circle--update');
        }, 2000);

    }

    self.updateCountry = function() {
        var $select = $('.country-select');
        var $submitButton = $('.country-submitter');
        var $formInputs = $('.checkout-step__form input');

        $select.on('change', function(){
            $('#EcomOrderCustomerAccepted').removeAttr('required');

            removeValidation();
            

        });
    }

    self.updateVoucher = function() {
        var $form
        var $submitButton = $('.voucher-submitter');

        $submitButton.on('click', function(e){
            e.preventDefault();
            
            removeValidation()
        });

    }

    this.addToCart = function() {
        var $cartBtn = $('.accessory-delivery-time__add-to-cart');

        $cartBtn.click(function(event) {
            event.preventDefault();
            var $form = $(this).closest('form');
            self.ajaxSubmit($form);
        });
    }
    
    // Helper

    function removeValidation() {
        var $formInputs = $('.checkout-step__form input');
        var $form = $('#ordersubmit');

        $formInputs.each(function(index, el) {
            $(el).removeAttr('required');
        });

        $form.unbind("submit");
        $form.submit();

    }

    // Public functions
    return {
        init: init,
        ajaxSubmit: ajaxSubmit,
        ajaxMsg: ajaxMsg
    };

}();
